import { Box as CUIBox }     from '@chakra-ui/react';
import React                 from 'react'

interface IBoxProps {
	styles?: Styles;
}

const Box = (props: React.PropsWithChildren<IBoxProps>) => {
	const { children, styles: propStyles } = props;
	return (
		<CUIBox
			{...styles.container.base}
			{...propStyles}
			lg={styles.container.lg}
		>
			{children}
		</CUIBox>
	)
}

export default Box;

const styles: Styles = {
	container: {
		base: {
			display: "flex",
			flexDirection: "column",
			gap: "30px",
			maxWidth: "500px",
			backgroundColor: "white",
			rounded: "md",
			shadow: "md",
			paddingTop: "20px",
			paddingRight: "20px",
			paddingBottom: "20px",
			paddingLeft: "20px",
		},
		lg: {
			display: "flex",
			flexDirection: "column",
			gap: "30px",
			maxWidth: "500px",
			backgroundColor: "white",
			rounded: "md",
			shadow: "md",
			paddingTop: "30px",
			paddingRight: "40px",
			paddingBottom: "30px",
			paddingLeft: "40px",
		}
	},
};